export default __webpack_public_path__ + "static/media/Bugatti.67ff97e6.png";